import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import ManagerRoutes from './manager/ManagerRoutes';
import RegistryGate from './session/RegistryGate';
import { RegistryProvider } from './store/RegistryStore';
import { ToastProvider } from './ui/feedback';
import { managerTheme } from './ui/theme';

/**
 * The staff Registry console: signed in, gated on /registry/me, manager screens only (the
 * prototype's investor screens are not routed here). Screens not yet wired to the API still
 * run on the prototype's mock store.
 */
export default function RegistryApp({ audience }: { audience?: string }) {
  return (
    <ThemeProvider theme={managerTheme}>
      <CssBaseline />
      <RegistryGate audience={audience}>
        <RegistryProvider>
          <HashRouter>
            <ToastProvider>
              <Routes>
                <Route path="/manager/*" element={<ManagerRoutes />} />
                <Route path="*" element={<Navigate to="/manager" replace />} />
              </Routes>
            </ToastProvider>
          </HashRouter>
        </RegistryProvider>
      </RegistryGate>
    </ThemeProvider>
  );
}
